<template>
    <div class="col-sm-8 col-md-8 col-lg-4 align-self-center">
        <div class="card">
            <div class="card-body p-sm-3 p-md-5">
                <form @submit.prevent="handle">
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="Code" v-model="form.code" required />
                        <p v-if="error" class="text-secondary font-weight-bold" style="font-size: 80%">{{error}}</p>
                    </div>
                    <button type="submit" class="btn btn-secondary w-100">Login</button>
                </form>
            </div>
        </div>
        <p class="text-muted text-center my-5" style="font-size: 80%">
            Door in te loggen geef je aan dat de doelstelling van dit programma je bekend is en dat je toestemming geeft om jouw video-opnames naar de betreffende server te uploaden.<br/><br/>
            By logging in you acknowledge you know the goal of this program and you give permission to upload your video recordings to our server.
        </p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                error: false,
                form: {
                    code: undefined
                }
            }
        },
        methods: {
            handle() {
                let code = this.form.code.trim();
                this.$api.login(code)
                .then((response) => {
                    if(response.data.errortext) {
                        this.error = response.data.errortext;
                        this.log(code + ': Incorrect login, error: ' + response.data.errortext, true);
                    } else {

                        if(response.data.moetbetalen === 1) {
                            this.log(code + ': Must pay.', true);
                            this.error = this.$t('login_must_pay');
                            return;
                        }

                        this.$state.logged_in = code;
                        this.$state.login_info = response.data;

                        this.error = false;
                        this.log(code + ': Successfully logged in.');

                        var _navigator = {};
                        for (var i in navigator) _navigator[i] = navigator[i];

                        this.log(JSON.stringify(_navigator));
                    }

                    return this.$router.push({name: 'welcome'});
                }).catch((error) => {
                    this.log(code + ': Login error: ' + error, true);

                    if(error)
                        this.log(error.response, true);
                });
            }
        }
    }
</script>
